export const DevUrl = "https://api-dev.winvesta.in/portal/v1";
export const UatUrl = "https://api-uat.winvesta.in/portal/v1";
export const ProdUrl = "https://api.winvesta.in/portal/v1";